import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { NbDialogService, NbToastrService } from "@nebular/theme";
import { MapService } from "../../../services/map.service";
import { Map, View, Feature } from "ol";
import { Vector as VectorLayer } from "ol/layer";
import {  Vector as VectorSource } from "ol/source";
import { GeoJSON, WFS } from "ol/format";
import { Stroke, Style,Icon } from "ol/style";
import TileLayer from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";
import { EcosistemasService } from 'src/app/services/ecosistemas.service';
import { MainService } from 'src/app/services/main.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-capas-principales',
  templateUrl: './capas-principales.component.html',
  styleUrls: ['./capas-principales.component.scss']
})
export class CapasPrincipalesComponent implements OnInit {
  
  @Input() map: Map;
  @Input() empresas_checked: any

  cambiado = false;
  listaElementos: any[] = [];
  coberturas: any[] = [];
  cors=  '';// 'https://cors-anywhere.herokuapp.com/'
  cors2=  'https://cors-anywhere.herokuapp.com/';
  urlGeoserver = environment.geoserverBaseUrl;

  menu: any[] = [];
  urlActiva: any;
  opcionesA = false;
  opcionesB = false;
  actualizado = false;
  itemActivo = 0;
  empresaSeleccionada: any;
  tileL: any;
  capas: any[] = [];
  mapId: string;
  s1: any;
  s2: any;
  toggle:boolean = true;
  toggle_leyenda:boolean = true;
  toggle_MapaBase:boolean = true;
  toggle_capa:boolean = true;
  toggle_medir:boolean = true;
  toggle_info:boolean = true;
  toggle_principal:boolean = true;
  toggle_AVC:boolean = true;
  toggle_florafauna:boolean = true;
  toggle_cambios_coberturas:boolean = true;
  toggle_menudesplegable:boolean = true;
  toggle_swipe:boolean = true;

  value: number = 100;
  public usuarioActivo: any;
  todas_empresas: any[];
  empresas_usuario: any[];
  empresas_nombre : any[];
  capas_tematicas: any;
  arr11 = [];
  arr12 = [];
  arr13 = [];
  arr14 = [];
  arr15 = [];
  arrleyenda = [];
  public arrinfo = [];
  start_date: String;
  end_date: String;
  info_array: [];
  ZoomToJson;
  geojson;

  styleRecreacion = new Style({
    image: new Icon({
      anchor: [0.5, 46],
      src: '/assets/icons-png/Recreacion.png',
    })
  })

  basemap = [];

  grupodelayers=[
    {name: 'Areas AVC HCS',id:'AVC', visible:false},
    {name: 'Registros de Fauna y Flora',id:'faunaflora',visible:false},
    {name: 'Cambios de Cobertura',id:'Cambios_Cobertura', visible:false}
  ]

  gfw= [
    {name:'gain',label:'Ganancia', url: '',value:'gain'},
    {name:'loss',label:'Perdida', url: '',value:'gain'},
  ]
  filtroGEP: any;

  constructor(
    public mapService: MapService,
    public mainService: MainService,
    private ecosistemasService: EcosistemasService
  ) {
    this.listaElementos.push({
      posx: 0,
      posy: 0,
    });
    this.coberturas.push({
      posx: 0,
      posy: 60,
    });
    this.menu.push({
      posx: 0,
      posy: 80,
    });
    this.ecosistemasService.capas_tematicas$.subscribe( variable => {
      this.capas_tematicas = variable
    })
    this.mainService.filtroGEP$.subscribe( variable => {
      this.filtroGEP = variable;
    })
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  ngOnInit() {
    this.capas_tematicas.forEach(capa => {
      switch(capa.grupo){
        case 11:
          this.arr11.push(capa);
          break;
        case 12:
          this.arr12.push(capa);
          break;
        case 13:
          this.arr13.push(capa);
          break;
        case 14:
          this.arr14.push(capa);
          break;
        case 15:
          this.arr15.push(capa);
          break;
      }
    })
  }
  
  AbrirControldeCapas(){
    this.toggle = !this.toggle;
    if(this.toggle ==  true){
      this.toggle_principal = true;
      this.toggle_AVC = true;
      this.toggle_florafauna = true;
      this.toggle_cambios_coberturas = true;
    }
  }


  async opcionesCapa(event: any, id){
    let position = 1;
    let capaIndex = this.capas_tematicas.findIndex( capa => capa.name == id)
    let params = {}
    if(capaIndex != -1 && event.target.checked){
      this.capas_tematicas[capaIndex].checked = "true";
      if(this.capas_tematicas[capaIndex].grupo== 12){
          params = {LAYERS: this.capas_tematicas[capaIndex].value}
      }
      if(this.capas_tematicas[capaIndex].style =='' && this.capas_tematicas[capaIndex].grupo!= 12){
        params = {LAYERS: this.capas_tematicas[capaIndex].value, CQL_FILTER:'id_empresa IN ('+this.empresas_checked+')'};
      }

      if(this.capas_tematicas[capaIndex].style !=''){
        await this.mapService.callLayer(this.filtroGEP, this.capas_tematicas[capaIndex].value).then( geojson => {
          var icon = this.capas_tematicas[capaIndex].style;
          var name_capa = this.capas_tematicas[capaIndex].name;
          var source_wfs = new VectorSource({
          features: (new GeoJSON({
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857'
          })).readFeatures(geojson)
          });

          var lv = new VectorLayer({
            visible: true,
            source: source_wfs,
            style: new Style({
              image: new Icon({
                src: 'assets/icons-png/'+icon,
              })
            }),
          });
          lv.set('name', name_capa);
          this.map.addLayer(lv);
        });
      }else{
        var source_wms = new TileWMS({
          url: this.urlGeoserver+'/wms',
          params: params,
          serverType: 'geoserver',
        });
        var l = new TileLayer({
          visible: true,
          opacity: 1,
          //crossOrigin: 'anonymous',
          source: source_wms,
        });
        l.set('name', this.capas_tematicas[capaIndex].name);
        this.map.getLayers().insertAt(position,l);
      }
    }
    if(capaIndex != -1 && !event.target.checked){
      this.capas_tematicas[capaIndex].checked = "false";
      this.map.getLayers().forEach( lyr => {
        if(lyr && lyr.get('name') == id){
          this.map.removeLayer(lyr);
        }
      });
    }
    this.ecosistemasService.updateCapasTematicas(this.capas_tematicas);
  }
  Transparencia(event: any,capa){

    this.map.getLayers().forEach(lyr => {
      if(lyr.get('name') == capa){
        lyr.setOpacity(event/100);
      }
    });
  }
  async ZoomTo(event: any, id){
  let filterstring = ''
  if(this.start_date && this.end_date){
    filterstring = "%20AND%20fecha>='"+this.start_date+"'%20AND%20fecha<='"+ this.end_date +"'&";
  }
  await this.mapService.callLayer(this.filtroGEP, id, filterstring).then( geojson => {
    this.zoomToGeojson(geojson);
  });
  }

zoomToGeojson(ZoomToJson){
  var shapeLayer = new VectorLayer({
    source: new VectorSource({
      features: (new GeoJSON({
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857'
      })).readFeatures(ZoomToJson)
    }),
    style: new Style({
      stroke: new Stroke({
        color: '#000000',
        width: 0
      }),
    })
  });
  console.log(shapeLayer);
  this.map.addLayer(shapeLayer);

  var vectorSource = shapeLayer.getSource();
  var extent =  vectorSource.getExtent();
  console.log(extent);
  this.map.getView().fit(extent);
  this.map.removeLayer(shapeLayer);
}

desplegarMenu(event, id){
  //this.toggle_menudesplegable = !this.toggle_menudesplegable;
  for(var i=0; i in this.capas_tematicas; i++){
    
    if(this.capas_tematicas[i].name == id){
        var name = this.capas_tematicas[i].name + "icon";
        if(document.getElementById(name).className == 'nb-close'){
          document.getElementById(this.capas_tematicas[i].value).style.display = 'none';
          document.getElementById(name).className = 'nb-plus'; 
        }else{
          document.getElementById(this.capas_tematicas[i].value).style.display = 'inline-flex'; 
          document.getElementById(name).className = 'nb-close'; 
        }
        
    }
  }
}
remover_bloque_capas(array){
  array.forEach( l => {
    let capaIndex = this.capas_tematicas.findIndex( capa => capa.name == l.name)
    this.capas_tematicas[capaIndex].checked = "false";
    this.map.getLayers().forEach( lyr => {
      if(lyr && lyr.get('name') == l.name){
        this.map.removeLayer(lyr);
      }
    });
  })
}

checkModulo(event: any, id) { 
  if(id == 'AVC'){
     this.toggle_AVC = !this.toggle_AVC;
     if(this.toggle_AVC){
      this.remover_bloque_capas(this.arr13)
      this.remover_bloque_capas(this.arr14)
     }
   }
   if(id == 'faunaflora'){
     this.toggle_florafauna = !this.toggle_florafauna;
     if(this.toggle_florafauna){
      this.remover_bloque_capas(this.arr15)
     }
   }
   if(id == 'Cambios_Cobertura'){
     this.toggle_cambios_coberturas = !this.toggle_cambios_coberturas;
     if(this.toggle_cambios_coberturas){
      this.remover_bloque_capas(this.gfw)
     }
   } 
}
}
